import { configureStore } from "@reduxjs/toolkit";
import { alliancesReducer } from "./slices/alliancesSlice";
import { errorsReducer } from "./slices/errorsSlice";
import { uptimeReducer } from "./slices/uptimeSlice";

export const store = configureStore({
  reducer: {
    alliances: alliancesReducer,
    errors: errorsReducer,
    uptime: uptimeReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
